import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';
import { UtilsService } from '../../shared/utils-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-enquiry-history-by-other',
  templateUrl: './enquiry-history-by-other.component.html',
  styleUrls: ['./enquiry-history-by-other.component.css']
})
export class EnquiryHistoryByOtherComponent implements OnInit {
private loader: boolean= false;
private showAdvanced: boolean;
	private range=0;
	private listLength = 0;
	private searchById:boolean;
	private showPopup:boolean;
	private searchUrl: string = this.utils.url+'/auditTrail/searchSingleSubmissionHistory';
	private result: any = [];
	private list: any = [];
	search: any = {};
	displayedColumns: any = [];
	private currDate: Date;
	private currEle:any={};
	private telcoURL: string = this.utils.url+"/auditTrail/searchAuditLogDetails";
	dataJson: any = [];
	private loggedInUser: any = {};
	
	constructor(private http: Http, private utils: UtilsService, private router: Router, private matSnackBar: MatSnackBar) {
		this.showAdvanced = true;
		this.searchById=false;	
		this.showPopup=false;	
		this.loggedInUser = this.utils._checkSession({'page': 'telco-audit-trail'});
	}

	@ViewChild(MatPaginator) paginator : MatPaginator;
	@ViewChild(MatSort) sort : MatSort;

	ngOnInit() {
		//this.searchData();
		this.displayedColumns = ['icNo', 'newIcNo', 'brNo', 'name', 'enquiryDate', 'userId', 'enquiredByComp', 'ddmfStatus', 'action'];
	}

	ngAfterViewInit() {
		// this.search.enquiredBy = "ddmfAll";	
		//this.search.ddmfStatus = "";	
	}

	resetData(){
   this.search = {};
    this.result = [];
	this.result.sort = this.sort; 
	this.list = [];
	this.listLength=0;
  }

	searchData() {
	this.range=0;
	/*if(this.search.userId){
		var usr = this.search.userId;
	} else {
		usr = this.loggedInUser.userId;
	}*/
	var usr = this.search.userId;
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);


		this.displayedColumns = ['icNo', 'newIcNo', 'brNo', 'name', 'enquiryDate', 'userId', 'enquiredByComp', 'ddmfStatus', 'action'];

		let data = JSON.stringify({
			"icOrNicNo":this.search.icOrNicNo,
			"brNo":this.search.brNo,
			"name":this.search.name,
			"ddmfStatus":"Found",
			"enquiredBy":"DDMF-Others",
			"userId":usr,
			"loginUserId": this.loggedInUser.userId,
			"dateRangeFrom":this.utils.dateToDB(this.search.dateRangeFrom),
			"dateRangeTo":this.utils.dateToDB(this.search.dateRangeTo),
			"paginationAttribute":
		{
			"totalRecordCount":0,
			"recordRangeFrom":this.range,
			"recordRangeTo":10
		}
		});
		//console.log(data, 'headers');
		if(this.search.icOrNicNo!=undefined || this.search.brNo!=undefined || this.search.name!=undefined || this.search.dateRangeFrom!=undefined || this.search.dateRangeTo!=undefined)	{						
     if(this.search.icOrNicNo!="" || this.search.brNo!="" || this.search.name!="" || this.search.dateRangeFrom!="" || this.search.dateRangeTo!=""){
     this.loader=true;
		this.http.post(this.searchUrl, data, {headers: headers}).subscribe(data => {
		this.loader=false;
			let json = JSON.parse(data['_body']);
			this.list = json['transCustomerList'];
			//console.log(this.list);
			if(json['transCustomerList'] == null){
				var message=json['ddmfResponseStatus'].responseStatusMessage;
	   			this.utils.notify(message);
    			this.result = [];
				this.result.sort = this.sort; 
    		} else {
				this.result = new MatTableDataSource(json['transCustomerList']);
				this.listLength = json['paginationAttribute'].totalRecordCount;
				this.result.sort = this.sort;
				//console.log(json, 'json');
			}
		},
		error => {
		this.loader=false;
	   		this.utils.notify('Something went wrong!! Please try after some time.');
		})
		}
		else{
  		this.utils.notify('Please enter the fields.');
  	}
  	}
  	else{
  		this.utils.notify('Please enter the fields.');
  	}
	}
	searchPrevData(e, page) {
	
		


		if (page == "first") {
			this.range = 0;
		} else if (this.range > 0) {
			this.range = this.range - 10;
		}
	/*if(this.search.userId){
		var usr = this.search.userId;
	} else {
		usr = this.loggedInUser.userId;
	}*/
	var usr = this.search.userId;
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);


		this.displayedColumns = ['icNo', 'newIcNo', 'brNo', 'name', 'enquiryDate', 'userId', 'enquiredByComp', 'ddmfStatus', 'action'];

		let data = JSON.stringify({
			"icOrNicNo":this.search.icOrNicNo,
			"brNo":this.search.brNo,
			"name":this.search.name,
			"ddmfStatus":"Found",
			"enquiredBy":"DDMF-Others",
			"userId":usr,
			"loginUserId": this.loggedInUser.userId,
			"dateRangeFrom":this.utils.dateToDB(this.search.dateRangeFrom),
			"dateRangeTo":this.utils.dateToDB(this.search.dateRangeTo),
			"paginationAttribute":
		{
			"totalRecordCount":0,
			"recordRangeFrom":this.range,
			"recordRangeTo":10
		}
		});
		//console.log(data, 'headers');
		if(this.search.icOrNicNo!=undefined || this.search.brNo!=undefined || this.search.name!=undefined || this.search.dateRangeFrom!=undefined || this.search.dateRangeTo!=undefined)	{						
     if(this.search.icOrNicNo!="" || this.search.brNo!="" || this.search.name!="" || this.search.dateRangeFrom!="" || this.search.dateRangeTo!=""){
     this.loader=true;
		this.http.post(this.searchUrl, data, {headers: headers}).subscribe(data => {
		this.loader=false;
			let json = JSON.parse(data['_body']);
			this.list = json['transCustomerList'];
			//console.log(this.list);
			if(json['transCustomerList'].length == 0){
				var message=json['ddmfResponseStatus'].responseStatusMessage;
	   			this.utils.notify(message);
    			this.result = [];
				this.result.sort = this.sort; 
    		} else {
				this.result = new MatTableDataSource(json['transCustomerList']);
				this.listLength = json['paginationAttribute'].totalRecordCount;
				this.result.sort = this.sort;
				//console.log(json, 'json');
			}
		},
		error => {
		this.loader=false;
	   		this.utils.notify('Something went wrong!! Please try after some time.');
		})
		}
		else{
  		this.utils.notify('Please enter the fields.');
  	}
  	}
  	else{
  		this.utils.notify('Please enter the fields.');
  	}
	}
	searchNextData(e, page) {
	
		
		if (page == "last") {
			this.range = (this.listLength-(this.listLength % 10));
		} else if ((this.range + 10) < this.listLength) {
			this.range = this.range + 10;
		}
	/*if(this.search.userId){
		var usr = this.search.userId;
	} else {
		usr = this.loggedInUser.userId;
	}*/
	var usr = this.search.userId;
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);


		this.displayedColumns = ['icNo', 'newIcNo', 'brNo', 'name', 'enquiryDate', 'userId', 'enquiredByComp', 'ddmfStatus', 'action'];

		let data = JSON.stringify({
			"icOrNicNo":this.search.icOrNicNo,
			"brNo":this.search.brNo,
			"name":this.search.name,
			"ddmfStatus":"Found",
			"enquiredBy":"DDMF-Others",
			"userId":usr,
			"loginUserId": this.loggedInUser.userId,
			"dateRangeFrom":this.utils.dateToDB(this.search.dateRangeFrom),
			"dateRangeTo":this.utils.dateToDB(this.search.dateRangeTo),
			"paginationAttribute":
		{
			"totalRecordCount":0,
			"recordRangeFrom":this.range,
			"recordRangeTo":10
		}
		});
		//console.log(data, 'headers');
		if(this.search.icOrNicNo!=undefined || this.search.brNo!=undefined || this.search.name!=undefined || this.search.dateRangeFrom!=undefined || this.search.dateRangeTo!=undefined)	{						
     if(this.search.icOrNicNo!="" || this.search.brNo!="" || this.search.name!="" || this.search.dateRangeFrom!="" || this.search.dateRangeTo!=""){
     this.loader=true;
		this.http.post(this.searchUrl, data, {headers: headers}).subscribe(data => {
		this.loader=false;
			let json = JSON.parse(data['_body']);
			this.list = json['transCustomerList'];
			//console.log(this.list);
			if(json['transCustomerList'].length == 0){
				var message=json['ddmfResponseStatus'].responseStatusMessage;
	   			this.utils.notify(message);
    			this.result = [];
				this.result.sort = this.sort; 
    		} else {
				this.result = new MatTableDataSource(json['transCustomerList']);
				this.listLength = json['paginationAttribute'].totalRecordCount;
				this.result.sort = this.sort;
				//console.log(json, 'json');
			}
		},
		error => {
		this.loader=false;
	   		this.utils.notify('Something went wrong!! Please try after some time.');
		})
		}
		else{
  		this.utils.notify('Please enter the fields.');
  	}
  	}
  	else{
  		this.utils.notify('Please enter the fields.');
  	}
	}
	goToURL(url){
		this.router.navigateByUrl(url);
		}
	viewDetails(ele) {
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
		/*let data = {
			"userId":this.loggedInUser.userId,
			"isEnquiryAllTelco": "false",
			"enquireBlackListSearchCriteriaList": [ele]
		} */
		let data = {
			"transId": ele['transId']
		};
		this.currEle = ele;
		//console.log(this.currEle,'currentElement');
		let bodyJson = JSON.stringify(data);

		 // console.log(bodyJson);
		this.loader=true;
		this.http.post(this.telcoURL, bodyJson, {headers: headers}).subscribe(res => {
		this.loader=false;
			let result = JSON.parse(res['_body']);
			// console.log(result, 'result....');
			this.dataJson = [result];
			this.showPopup = true;
		},
		error => {
		this.loader=false;
			// this.matSnackBar.open('Something went wrong!! Please try after some time.', 'Close', {
   //    			duration: 5000,
   //  		});
	   		this.utils.notify('Something went wrong!! Please try after some time.');
		});
		this.currDate = new Date();
	}

	export () {
		// console.log(this.list);
		this.utils.exportCSV(this.list, 'EnquiryHistoryOthers.csv', this.displayedColumns);
	}
	
	dateValidateLeapYear(e, val, field){
		var res = val.split("-");
		if(val.length>'0'&&val.length<'10'){
			this.utils.notify('Invalid Date Format');
			this.search[field] = "";
		}
		else if(res[0]=='0000'){
			this.utils.notify('Year is Invalid');
			this.search[field] = "";
		}
		else if(res[1]>'12'||res[1]=='00'){
			this.utils.notify('Month is Invalid');
			this.search[field] = "";
		}
		else if(res[2]>'31'||res[2]=='00'){
			this.utils.notify('Date is Invalid');
			this.search[field] = "";
		}
		else if(res[2]<'32'&&res[2]!='00'){
			if(res[1]=='01' || res[1]=='03'|| res[1]=='05' || res[1]=='07' || res[1]=='08' || res[1]=='10' || res[1]=='12'){			
			}
			else{
				if(res[2]=='31'){
					this.utils.notify('Date is Invalid');
					this.search[field] = "";
				}
				else if(res[1]=='02'){
					if(((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0))
					{
						if(res[2]>'29'){
							this.utils.notify('Date is Invalid');
							this.search[field] = "";
						}						
					}
					else{
						if(res[2]>'28'){
							this.utils.notify('Date is Invalid');
							this.search[field] = "";
						}
					}
				}
			}
		}
	}
	
	dateValidate(e, val, field){
		if(e.charCode >= 48 && e.charCode <= 57){
		//console.log(val.length);
			if(val.length == 4){
				val= val+'-';
				//console.log(val);
				this.search[field] = val;
			} else if(val.length == 7){
				val= val+'-';
				//console.log(val);
				this.search[field] = val;
			}
			//console.log(val, 'value', this.search[field], field);
		} else {
			e.preventDefault();
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/telco-audit-trail/enquiry-history-by-other/enquiry-history-by-other.component.ts